import React from 'react';

import { LoadingType } from 'prequalificationV2/actions';
import Loader from 'components/Loader';
import { DocumentCategory } from 'enums/DocumentCategory';
import { useAppSelector } from 'prequalificationV2/hooks/useAppSelector';
import { getDocumentsByCategory, isDocumentCategoryCompleted } from 'prequalificationV2/utils/documentsUtils';
import { DashboardTabName } from 'enums/DashboardTabName';
import UploadDocumentCategory from 'prequalificationV2/components/LoanPortal/UploadDocuments/UploadDocumentCategory';
import Section from 'prequalificationV2/components/LoanPortal/Sections/Section';

import styles from '../InformationTabs.module.scss';

const WorkOrderTab = () => {
  const loading = useAppSelector(
    (state) => state.loading[`${LoadingType.RequiredInformationUpdating}${DashboardTabName.WorkOrder}`],
  );

  const { requiredDocuments } = useAppSelector((state) => state.documents);

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <div className={styles.requiredInformationContainer}>
          <Section
            title={'Work Order'}
            subSectionStates={[
              {
                isExist: true,
                isCompleted: isDocumentCategoryCompleted(requiredDocuments, DocumentCategory.ContractorWorkOrder),
              },
            ]}
          >
            <UploadDocumentCategory
              documents={getDocumentsByCategory(requiredDocuments, DocumentCategory.ContractorWorkOrder)}
              category={DocumentCategory.ContractorWorkOrder}
            />
          </Section>
        </div>
      )}
    </>
  );
};

export default WorkOrderTab;
